import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Breadcrumb from "../layouts/Breadcrumb";
import Footerthree from "../layouts/Footerthree";
// import Content from "../sections/sell/Content";
import ServiesCards from "../sections/services/ServiesCards";
import SellerGuide from "../sections/services/SellerGuide";
import { useTranslation } from "react-i18next";
import InfoGraphic from "../sections/services/Inforgrapic";

const Sell = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Helmet>
        <title>Buy Home For Less | Sell</title>
        <meta name="description" content="#" />
      </Helmet>
      <Header />
      <Breadcrumb breadcrumb={{ pagename: t("sell") }} />
      <ServiesCards />
      <SellerGuide />
      <InfoGraphic />

      <Footerthree />
    </Fragment>
  );
};

export default Sell;
